import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { Store } from 'antd/lib/form/interface';
import { Button, Layout, Modal, Table } from 'antd';
import { CriteriaForm, AuthButton, AuthButtonAuthorities, Checkbox } from '../../core/CoreForm'
import { Header, ContentEx as Content, FooterButtonArea, Footer, FunctionTitle, CommonMessage } from '../../core/CorePageContents'
import styles from './MutualAidProjectDetail.module.css';
import * as Module from '../../../modules/prime/mutual-aid/mutualAidModule';
import * as Model from '../../../modules/prime/mutual-aid/mutualAidModel';
import { initMessages, setMessages, message } from '../../../modules/core/commonMessageModule';
import * as CONSTANTS from '../../../constants/constants';
import * as messagesUtils from '../../../utils/messagesUtils';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import AuthButtonStyles from '../../core/css/AuthButton.module.css';
import { initApiResult, storedApiResult } from '../../../modules/core/bffApiModule';
import { RightSquareFilled, LeftSquareFilled } from '@ant-design/icons';
import moment from "moment";
import { storedLoginUserInfo } from '../../../modules/core/authModule';

interface titleInterface {
  title: string;
}

// チェックボックス
const CHECKBOX_CHECK = "1";
const CHECKBOX_NONE = "0";

export const MutualAidProjectDetail = (props: titleInterface) => {

  const dispatch = useDispatch();
  let dataList = useSelector(Module.storedDetailDataList);
  let detailSummaryDataList = useSelector(Module.storedDetailSummaryDataList);
  let allSelect: boolean = useSelector(Module.storedAllSelect);
  let criteria = useSelector(Module.storedDetailCriteria);
  let summaryCriteria = useSelector(Module.storedListCriteria)
  let total = useSelector(Module.storedDetailTotal);
  let projectId = useSelector(Module.storedProjectId);
  let projectName = useSelector(Module.storedProjectName);
  let branchName = useSelector(Module.storedBranchName);
  let existAvailableRow = useSelector(Module.storedExsitAvailabletRow);
  const apiResult = useSelector(storedApiResult);
  let history = useHistory();
  let checkedMutualAidStatusCount = useSelector(Module.storedCheckedMutualAidStatusCount);
  let requestModalDisagreeVisibleState = useSelector(Module.storedRequestModalDisagreeVisibleState);
  let loginUserInfo = useSelector(storedLoginUserInfo);
  const termsCheck = useSelector(Module.serviceTermsCheckState);

  useEffect(() => {
    callGetDetailDataListApi();
  },
    [criteria]
  );

  /**
   * 全選択チェックボックスを表示するか
   */
  const isDisplayCheckBox = () => {

    // 処理できる行がある場合に表示
    return existAvailableRow;
  }

  /**
   * 申請ボタンを押せるかどうか
   * @returns 
   */
  const isEnableRequestButton = (): boolean => {

    return checkedMutualAidStatusCount.submitted == 0
      && checkedMutualAidStatusCount.approved > 0
      && checkedMutualAidStatusCount.requested == 0
      && checkedMutualAidStatusCount.linked == 0
  }

  /**
   * 差戻ボタンが押せるかどうか
   * @returns 
   */
  const isEnableRequestCancelButton = (): boolean => {

    return checkedMutualAidStatusCount.submitted == 0
      && checkedMutualAidStatusCount.approved == 0
      && (checkedMutualAidStatusCount.requested > 0
      || checkedMutualAidStatusCount.linked > 0)
  }

  /**
   * CriteriaをStoreに保持
   * @param keyValueList 
   */
  const criteriaDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let newCriteria: Model.MutualAidProjectDetailCriteria = {
      attendanceYearMonth: criteria.attendanceYearMonth,
      submitted: criteria.submitted,
      approved: criteria.approved,
      requested: criteria.requested,
      linked: criteria.linked,
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      newCriteria[rec.key] = rec.value;
    })
    dispatch(Module.setCriteria(newCriteria));
  }

  if (criteria.attendanceYearMonth === ""
    && projectId === "") {
    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_PROJECT_LIST);
  }

  const SelectCheckbox = (row: Model.MutualAidProjectDetailRow) => {
    return (
      <Checkbox
        checked={row.selectFlag}
        onChange={(e) => onChangeCheck(e, row)}
      >
      </Checkbox>
    )
  }

  /** 集計部 */
  const sumColumns = [
    {
      title: "掛金対象者数合計",
      className: styles.total,
      key: "1",
      width: 250,
      dataIndex: "total",
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidProjectDetailSummaryRow) => {
        return (
          <>
            <div className={styles.columnAlignCenterNumber}>{row.total}</div>
          </>
        )
      },
    },
    {
      title: "掛金申請状況",
      className: styles.status,
      width: 200,
      showSorterTooltip: false,
      colSpan: 4,
      dataIndex: "submitted",
      render: (text: string, row: Model.MutualAidProjectDetailSummaryRow, index: number) => {
        return (
          <>
            <div className={styles.columnAlignCenter}>未承認</div>
            <div className={styles.columnAlignCenterNumber}>{row.submitted}</div>
          </>
        )
      },
    },
    {
      className: styles.status,
      colSpan: 0,
      width: 200,
      render: (text: string, row: Model.MutualAidProjectDetailSummaryRow, index: number) => {
        return (
          <>
            <div className={styles.columnAlignCenter}>未申請</div>
            <div className={styles.columnAlignCenterNumber}>{row.approved}</div>
          </>
        )
      },
    },
    {
      className: styles.status,
      colSpan: 0,
      width: 200,
      render: (text: string, row: Model.MutualAidProjectDetailSummaryRow, index: number) => {
        return (
          <>
            <div className={styles.columnAlignCenter}>申請済</div>
            <div className={styles.columnAlignCenterNumber}>{row.requested}</div>
          </>
        )
      },
    },
    {
      className: styles.status,
      colSpan: 0,
      width: 200,
      render: (text: string, row: Model.MutualAidProjectDetailSummaryRow, index: number) => {
        return (
          <>
            <div className={styles.columnAlignCenter}>連携済</div>
            <div className={styles.columnAlignCenterNumber}>{row.linked}</div>
          </>
        )
      },
    },
  ];

  /** 一覧部 */
  let columns = [
    {
      title: (
        <>
          <span>選択</span><br />
          <Checkbox
            className={styles.checkBox}
            checked={allSelect}
            onChange={(e: any) => dispatch(Module.onChangeAllSelect(e))}
            style={{ display: `${!isDisplayCheckBox() ? "none" : "inline"}` }}
          >
          </Checkbox>
        </>
      ),
      dataIndex: 'selectFlag',
      key: 'selectFlag',
      className: styles.select,
      align: 'center' as 'center',
      width: "80px",
      render: (text: string, row: Model.MutualAidProjectDetailRow) => {
        if (row.approvalStatus != CONSTANTS.ATTENDANCE_STATUS_APPROVED) {
          return <></>
        } else if (row.isEnableAttendanceProcess) {
          return SelectCheckbox(row);
        } else {
          return <></>
        }
      }
    },
    {
      title: '状態',
      className: styles.status,
      align: 'center' as 'center',
      width: "100px",
      render: (text: string, row: Model.MutualAidProjectDetailRow) => {
        let label = "";
        if (row.approvalStatus != CONSTANTS.ATTENDANCE_STATUS_APPROVED) {
          label = "未承認";
        } else {
          switch (row.offerFlag) {
            case CONSTANTS.OFFER_FLAG_APPROVED:
              label = "未申請";
              break;
            case CONSTANTS.OFFER_FLAG_REQUESTED:
              label = "申請済";
              break;
            case CONSTANTS.OFFER_FLAG_LINKED:
              label = "連携済";
              break;
          }
        }
        return (
          <>
            <div className={styles.statusLayout}>
              <span>{label}</span>
            </div>
          </>
        )
      }
    },
    {
      title: '所属会社',
      className: styles.belongCompany,
      align: 'center' as 'center',
      width: "160px",
      render: (text: string, row: Model.MutualAidProjectDetailRow) =>
        <>
          <div className={styles.contentLeft}>
            <span>{row.belongCompanyName}</span>
          </div>
        </>
    },
    {
      title: '被共済者番号',
      className: styles.mutualAidInsuredNo,
      align: 'center' as 'center',
      width: "160px",
      render: (text: string, row: Model.MutualAidProjectDetailRow) =>
        <>
          <div className={styles.contentLeft}>
            <span>{!!row.mutualAidInsuredNo && row.mutualAidInsuredNo.length > 0 ? row.mutualAidInsuredNo : "-"}</span>
          </div>
        </>
    },
    {
      title: '被共済者氏名セイ',
      className: styles.lastNameKana,
      align: 'center' as 'center',
      width: "160px",
      render: (text: string, row: Model.MutualAidProjectDetailRow) =>
        <>
          <div className={styles.contentLeft}>
            <span>{row.lastNameKana}</span>
          </div>
        </>
    },
    {
      title: '被共済者氏名メイ',
      className: styles.firstNameKana,
      align: 'center' as 'center',
      width: "160px",
      render: (text: string, row: Model.MutualAidProjectDetailRow) =>
        <>
          <div className={styles.contentLeft}>
            <span>{row.firstNameKana}</span>
          </div>
        </>
    },
  ];

  const callGetDetailDataListApi = () => {
    // パラメータが存在しない場合、または、パラメータの値が不正の場合はデータを取得しない
    if (criteria.attendanceYearMonth === ""
      || projectId === "") {
      return;
    } else if (!moment(criteria.attendanceYearMonth + '01', 'YYYYMMDD', true).isValid()) {
      return;
    }

    let params: Model.getMutualAidProjectDetailDataList.Request = {
      attendanceYearMonth: criteria.attendanceYearMonth,
      projectId: projectId,
      submitted: criteria.submitted,
      approved: criteria.approved,
      requested: criteria.requested,
      linked: criteria.linked
    }
    dispatch(Module.getDetailDataListAsync(params));
  }

  // 建退共連携ステータス変更APIが正常終了した時の処理
  if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
    && "" === apiResult.errorCode
    && CONSTANTS.REQUEST_METHOD_PUT === apiResult.requestMethod
    && CONSTANTS.URL_MUTUAL_AID_PRIME_STATUS === apiResult.url) {

    const messageText = messagesUtils.getMessageTextFromSession();
    const messageType = messagesUtils.getMessageTypeFromSession() || CONSTANTS.MESSAGE_TYPE_SUCCESS;
    if (messageText !== null) {
      const setMessage: message = {
        message: messageText
        , messageType: messageType
      }
      dispatch(setMessages([setMessage]));

      messagesUtils.clearSessionMessage();
    }

    // API結果情報を初期化します。
    dispatch(initApiResult());

    callGetDetailDataListApi();
  }

  /**
   * 勤怠年月変更日イベント
   * @param addValue 
   */
  const onChangeMonth = (addValue: number) => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let year = parseInt(criteria.attendanceYearMonth.substring(0, 4));
    let month = parseInt(criteria.attendanceYearMonth.substring(4, 6));

    // 変更後の日付インスタンスの作成
    let newDate = new Date(year, (month - 1) + addValue, 1);

    year = newDate.getFullYear();
    month = newDate.getMonth() + 1;

    criteriaDataTransfer([
      { key: "attendanceYearMonth", value: year.toString() + ("0" + month).slice(-2) }
    ]);
  }

  const searchDataList = (value: Store) => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    criteriaDataTransfer([
      { key: "submitted", value: value.submitted === true ? "1" : "0" }
      , { key: "approved", value: value.approved === true ? "1" : "0" }
      , { key: "requested", value: value.requested === true ? "1" : "0" }
      , { key: "linked", value: value.linked === true ? "1" : "0" }
    ]);
  }

  /**
   * チェックボックス変更時イベント
   * @param e 
   * @param row 
   */
  const onChangeCheck = (e: CheckboxChangeEvent, row: Model.MutualAidProjectDetailRow) => {
    let transfer: Module.changeCheckTransfer = {
      targetDataRow: row,
      value: e.target.checked
    }

    dispatch(Module.onChangeRowSelect(transfer));
  }

  /**
   * 戻るボタン押下
   */
  const onClickBack = () => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let newCriteria: Model.MutualAidProjectListCriteria = {
      projectName: summaryCriteria.projectName,
      firstPartnerCompanyName: summaryCriteria.firstPartnerCompanyName,
      firstPartnerCompanyNameKana: summaryCriteria.firstPartnerCompanyNameKana,
      branchName: summaryCriteria.branchName,
      fromYYYYMM: summaryCriteria.fromYYYYMM,
      toYYYYMM: summaryCriteria.toYYYYMM,
      submitted: criteria.submitted,
      approved: criteria.approved,
      requested: criteria.requested,
      linked: criteria.linked,
      sortItem: summaryCriteria.sortItem,
      sortOrder: summaryCriteria.sortOrder,
      offset: summaryCriteria.offset,
      limit: summaryCriteria.limit,
    }
    dispatch(Module.setListCriteria(newCriteria));

    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_PROJECT_LIST);
  }

  /**
   * 各種処理ボタン押下
   * @param processType 処理種別 
   */
  const onClickProcess = async (processType: CONSTANTS.MUTUAL_AID_PROCESS_TYPE, agreeFlag = false) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let args = "";

    // 処理タイプ毎にメッセージを取得
    switch (processType) {
      case CONSTANTS.MUTUAL_AID_PROCESS_TYPE.REQUEST:
        args = "申請";
        break;
      case CONSTANTS.MUTUAL_AID_PROCESS_TYPE.REMAND:
        args = "差戻";
        break;
      default:
        return;
    }
    if (processType == CONSTANTS.MUTUAL_AID_PROCESS_TYPE.REQUEST) {
      let param = {
        primeCompanyId: loginUserInfo.belongCompanyId
      }
      // NowLoading表示
      dispatch(initApiResult());
      if (agreeFlag) {
        // 約款同意
        await dispatch(Module.putMutualAidTermsAgreeAsync(param));
        dispatch(Module.reflectRequestModalDisagreeVisibleState(false));
      } else {
        // 約款同意状況を取得
        let state = await dispatch(Module.getMutualAidTermsAgreeAsync(param)) as unknown;
        // 約款未同意の場合、約款同意ダイアログを表示して終了
        if (state != CONSTANTS.MUTUAL_AID_AGREEMENT_STATE_TYPE.AGREE) {
          dispatch(Module.setTermOfServiceCheck(CHECKBOX_NONE));
          dispatch(Module.reflectRequestModalDisagreeVisibleState(true));
          return;
        }
      }
    }

    // 確認ダイアログの表示
    if (!window.confirm(messagesUtils.getMessage("CONFIRM_MUTUAL_AID_PROCESS", [args]))) {
      return;
    }

    // API結果情報を初期化します。
    dispatch(initApiResult());

    // リクエストデータの作成
    let destList: Array<Model.putStatus.Dest> = [];
    dataList.forEach((data: Model.MutualAidProjectDetailRow) => {
      if (data.selectFlag) {
        // 選択されている
        let dest: Model.putStatus.Dest = {
          attendanceYearMonth: criteria.attendanceYearMonth,
          belongCompanyId: data.belongCompanyId,
          workerId: data.workerId,
          projectId: projectId,
          firstPartnerCompanyId: data.firstPartnerCompanyId,
          updateDatetime: data.updateDatetime
        }

        destList.push(dest);
      }
    });

    // メッセージをセッションストレージに保管
    let message = messagesUtils.getMessage("SUCCESS_ATTENDANCE_PROCESS", [args]);
    messagesUtils.setMessageInSession(message, CONSTANTS.MESSAGE_TYPE_SUCCESS);

    let putData: Model.putStatus.Request = {
      processType: processType,
      destList: destList
    }

    dispatch(Module.putMutualAidStatusAsync(putData));
  }

  // データ連携同意モーダル非表示アクション
  const hideRequestModalDisagree = () => {
    // モーダル非表示
    dispatch(Module.reflectRequestModalDisagreeVisibleState(false));
  }

  // CheckBox変更時処理
  const onChangeCheckModal = (value: any) => {
    // チェックボックスのステートを変更します。
    dispatch(Module.setTermOfServiceCheck(value.target.checked ? CHECKBOX_CHECK : CHECKBOX_NONE));
  }

  /** ログインユーザが企業担当者かどうか */
  const isCompanyStaff = (): boolean => {
    return CONSTANTS.MANAGER_FLAG.COMPANY_STAFF == loginUserInfo.managerFlag;
  }

  /** 検索部 */
  const Criteria = () => {
    return (
      <CriteriaForm
        layout="inline"
        onFinish={searchDataList}
        initialValues={{
          "submitted": criteria.submitted === "1" ? true : false
          , "approved": criteria.approved === "1" ? true : false
          , "requested": criteria.requested === "1" ? true : false
          , "linked": criteria.linked === "1" ? true : false
        }}>
        <div style={{ float: "right" }}>
          <div className={styles.statusWorkTimeGrid}>
            <div className={`${styles.statusWorkTimeTopLeft} ${styles.statusWorkTimeLeft}`}>
              <span>建退共連携ステータス：</span>
            </div>
            <div className={`${styles.statusWorkTimeTopRight} ${styles.statusWorkTimeRight}`}>
              <CriteriaForm.Item name="submitted" id="submitted" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  未承認
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="approved" id="approved" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  未申請
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="requested" id="requested" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  申請済
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="linked" id="linked" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  連携済
                </Checkbox>
              </CriteriaForm.Item>
            </div>
          </div>

          <AuthButton
            name={"検索"}
            shape={"round"}
            htmlType="submit"
          />
        </div>

      </CriteriaForm>
    )
  }

  /** 一覧ヘッダー部 */
  const MutualAidProjectDetailHeader = () => {
    return (

      <div style={{ whiteSpace: "nowrap" }} className={styles.searchGroup}>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle}>勤怠年月：</div>
          <div>
            <label style={{ color: "#006a5d", margin: "4px" }} onClick={(e) => onChangeMonth(-1)}><LeftSquareFilled /></label>
            {criteria.attendanceYearMonth.substring(0, 4)}年{parseInt(criteria.attendanceYearMonth.substring(4, 6))}月
            <label style={{ color: "#006a5d", margin: "4px" }} onClick={(e) => onChangeMonth(1)}><RightSquareFilled /></label>
          </div>
        </div>

        <div className={styles.flexContainer}>
          <div className={styles.headerTitle}>支店：</div>
          <div>{branchName}</div>
        </div>

        <div className={styles.flexContainer}>
          <div className={styles.headerTitle}>プロジェクト：</div>
          <div>{projectName}</div>
        </div>
      </div>


    )
  }

  /** ボタン部 */
  const MutualAidProjectButton = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          size={"large"}
          shape={"round"}
          onClick={onClickBack}
          className={AuthButtonStyles.backButtonFixed}
          style={{ margin: "10px" }}
        />

        <AuthButton
          name={"申請"}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={() => onClickProcess(CONSTANTS.MUTUAL_AID_PROCESS_TYPE.REQUEST)}
          className={AuthButtonStyles.authButtonFixed}
          disabled={!isEnableRequestButton()}
          style={{ margin: "10px" }}
        />
        <AuthButton
          name={"差戻"}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={() => onClickProcess(CONSTANTS.MUTUAL_AID_PROCESS_TYPE.REMAND)}
          className={AuthButtonStyles.authButtonFixed}
          disabled={!isEnableRequestCancelButton()}
          style={{ margin: "10px" }}
        />
      </FooterButtonArea>
    );
  }

  return (

    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        <Criteria />
        <div style={{ whiteSpace: "pre-line" }}>
          <CommonMessage searchNoDataName="被共済者" />
        </div>
        <MutualAidProjectDetailHeader />
        {0 < total && 0 < dataList.length ?
          <>
            
            <Table
              size="small"
              sticky={{ offsetHeader : -31 }}
              className="hoverNotBackground fit-table"
              columns={sumColumns}
              dataSource={detailSummaryDataList}
              pagination={false}
            >
            </Table>
            
            <div className={styles.headline} style={{marginTop: "10px"}}>
            </div>
            <Table
              size="small"
              sticky={{ offsetHeader : -31 }}
              className="hoverNotBackground"
              columns={columns}
              dataSource={dataList}
              pagination={false}
            >
            </Table>
          </>
          : <></>
        }
      </Content>
      <MutualAidProjectButton />
      <Footer />
      
      {/* データ連携同意ダイアログ */}
      <Modal
        visible={requestModalDisagreeVisibleState}
        footer={
          <>
            <AuthButton
              name={"閉じる"}
              size={"large"}
              shape={"round"}
              onClick={hideRequestModalDisagree}
              className={isCompanyStaff() ? AuthButtonStyles.backButtonFixed : AuthButtonStyles.authButtonFixed}
              style={{ margin: "10px" }}
            />
            {
              isCompanyStaff() ?
              <AuthButton
                name={"同意して送信する"}
                size={"large"}
                shape={"round"}
                onClick={() => {onClickProcess(CONSTANTS.MUTUAL_AID_PROCESS_TYPE.REQUEST, true)}} // アロー関数にすることでエラー回避
                className={AuthButtonStyles.authButtonFixed}
                disabled={termsCheck === CHECKBOX_NONE}
                style={{ margin: "10px" }}
              />
              : <></>
            }
          </>
        }
        destroyOnClose
        closable={false}
        width={900}
      >
        <Layout>
          <Content
            style={{ margin: "auto", textAlign: "center", fontSize: "16px", lineHeight: "2" }}
            hasapicall={"false"}>
            { 
              // 企業担当者の場合
              isCompanyStaff() ?
              <>
                <div style={{ fontSize: "18px", fontWeight: "bold", margin: "15px" }}>建退共連携機能の利用申し込み</div>
                <div style={{ textAlign: "left" }}>
                  <div>これより、スキルマップサイトに登録された就業実績を建退共電子申請専用サイトへ送信します。</div>
                  <div>本機能は、<a href={CONSTANTS.URL_KENSETSU_SITE_SERVICE_TERM_PDF} target="_blank">「建設サイト・シリーズ」サービス利用約款</a>第40条第5項に定める「外部プロダクト向けデータ連携サービス」の一部として提供されます。本機能を利用するには、申し込みが必要です。また、対象技能者の就業実績は建退共電子申請専用サイトへの申請に必要な範囲で送信されます。</div>
                  <div>利用条件の詳細は、「建設サイト・シリーズ」サービス利用約款および<a href={CONSTANTS.URL_KENSETSU_SITE_OWNER_TERM_PDF} target="_blank">「建設サイト・シリーズ」オーナー利用約款</a>をご確認ください。</div>
                  <div>「同意して送信する」を押下した時点で、本機能の利用に係る申し込みが完了し、契約が成立します。</div>
                </div>
                <div style={{ margin: "15px" }}><Checkbox checked={termsCheck !== CHECKBOX_NONE} onChange={onChangeCheckModal} style={{ fontSize: "16px" }}>建退共連携機能の利用条件に同意し、申し込みを行います。</Checkbox></div>
              </>
              // 企業担当者でない場合
              :
              <>
                <div style={{ fontSize: "18px", fontWeight: "bold", margin: "15px" }}>「企業担当者」に連携機能の利用申し込みをご依頼ください</div>
                <div style={{ textAlign: "left" }}>
                  <div>建退共電子申請専用サイトへ就労実績を送信するには、連携機能の利用申し込みが必要です。利用申し込みは「企業担当者」権限を持つユーザーのみ行えます。</div>
                  <div>お手数ですが、貴社の「企業担当者」に利用申し込みの手続きをご依頼ください。申し込みが完了すると、建退共電子申請専用サイトへ就労実績を送信できるようになります。</div>
                </div>
              </>
            }
          </Content>
        </Layout>
      </Modal>
    </Layout>
  );
}
